export default function About() {
    return (
        <div className="about-me-container">
            <h3 className="about-me">About</h3>
            <p className="about-info">
                I am currently studying full-stack web application development through Udemy courses and a reputuble bootcamp, Nucamp Bootcamp, learning html, css, javascript, node.js, react and react native. I prefer to build simple applications that provide sharp functionality and easy to pick up user experience.
            </p>
        </div>
    )
}